import { render, staticRenderFns } from "./c-select-choose.vue?vue&type=template&id=4af80912&"
import script from "./c-select-choose.vue?vue&type=script&lang=js&"
export * from "./c-select-choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports